import { Box, Typography, SxProps, Theme } from '@mui/material';

type SectionHeaderProps = Readonly<{
  title: string;
  description: string;
}>;

export const SectionHeader = ({ title, description }: SectionHeaderProps) => {
  return (
    <>
      <Box sx={headerTextSx}>
        <Typography variant="display-xs-semibold">{title}</Typography>
        <Typography variant="text-sm-regular">{description}</Typography>
      </Box>
      <Box sx={dividerSx} />
    </>
  );
};

const dividerSx: SxProps<Theme> = ({ backrs }) => ({
  borderBottom: `1px solid ${backrs.colors['Beige/950']}`,
  my: backrs.spacing['spacing-4xl'],
});

const headerTextSx: SxProps<Theme> = ({ backrs }) => ({
  mt: backrs.spacing['spacing-4xl'],
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
  paddingTop: backrs.spacing['spacing-md'],
  paddingLeft: { sm: backrs.spacing['spacing-3xl'] },
  paddingRight: {
    md: backrs.spacing['spacing-11xl'],
  },
  whiteSpace: 'pre-line',
});
